import { styled } from '../../Utilities';
import { DetailsRowBase } from './DetailsRow.base';
import { getDetailsRowStyles } from './DetailsRow.styles';
export var DetailsRow = styled(DetailsRowBase, getDetailsRowStyles, undefined, {
    scope: 'DetailsRow',
});
//# sourceMappingURL=DetailsRow.js.map